@if (item) {
  <mat-card>
    <mat-card-header class="bold-card-title">
      <mat-card-title>{{ item?.title }}</mat-card-title>
      @if (item.subtitle) {
        <mat-card-subtitle>{{ item.subtitle }}</mat-card-subtitle>
      }
    </mat-card-header>
    @if (item.image) {
      <img
        (click)="search.emit(item)"
        [alt]="item.title || item.subtitle"
        [src]="item.image"
        class="cursor-pointer max-w-none mt-2"
        mat-card-image
      />
    }
    @if (item.description) {
      <mat-card-content class="text-gray">
        <p class="py-2">
          {{ item.description }}
        </p>
        <mat-divider></mat-divider>
      </mat-card-content>
    }
    <mat-card-actions align="end">
      <button (click)="search.emit(item)"
              [ngClass]="['plausible-event-name=Catalog+Prepared+Query plausible-event-title='+item.title.replaceAll(' ', '+'), 'primary-button']"
              mat-button>
        {{ 'catalog.dashboard.search' | transloco }}
      </button>
    </mat-card-actions>
  </mat-card>
}
